import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    mode: "IDLE",
    speed: 1,
    planeLog: {}
}

const simSlice = createSlice( {
    name: 'sim',
    initialState,
    reducers: {
        startSim(state, action) {
            state.planeLog = {};
            state.time = action.payload;
            state.mode = "RUNNING";
        },
        stopSim(state) {
            state.mode = "IDLE";
        },
        setSpeed(state, action) {
            state.speed = action.payload;
        },
        tick(state, action) {
            const timePassed = action.payload;
            state.time = state.time + timePassed;
        },
        addLogEntry(state, action) {
            const time = new Date(state.time);
            const newEntry = {
                time: time.toLocaleTimeString(),
                text: action.payload.message
            };
            const planeId = action.payload.planeId;
            if (!state.planeLog[planeId]) {
                state.planeLog[planeId] = [];
            }
            state.planeLog[planeId].push(newEntry);
        }
    }
})

export const {startSim, stopSim,
    addLogEntry, setSpeed,
    tick} = simSlice.actions;
export const selectSim = state => state.sim;
export default simSlice.reducer;